import {
  EDVISOR_LOGIN_SETSTATE,
  EDVISOR_LOGIN_AUTHENTICATION,
  EDVISOR_LOGIN_GETMENUDETAILS,
  EDVISOR_LOGIN_PAGERESET,
  EDVISOR_FORGOT_PASSWORD,
  EDVISOR_VERIFY_OTP,
  EDVISOR_RESET_PASSWORD, // New import
} from "./EdvisorLoginActionType";

export interface MenuItem {
  MenuID: number;
  MenuName: string;
  MenuPath: string;
  MenuIcon: string;
  MenuComponent: string;
  ApplicationID: number;
  ParentMenuID: number;
  MenuOrder: number;
  IsAdminOnly: boolean;
  EmployeeID: number;
  EmployeeName: string | null;
  RoleName: string;
  IsAdmin: boolean;
  StatusCode: number;
  StatusMessage: string;
}

export interface LoginResponse {
  isSuccess: boolean;
  message: string;
  generatedLink: string | null;
  employeeId: number;
  employeeCode: string;
  employeeName: string;
  employeeAddress: string | null;
  mobileNumber: string;
  email: string;
  updatedOn: number[] | string;
  updatedBy: string;
  isActive: boolean;
  loginSuccess: boolean;
  id: number;
}

export interface MenuResponse {
  isSuccess: boolean;
  message: string;
  accessedOn: string | null;
  records: MenuItem[];
}

export interface ForgotPasswordResponse {
  isSuccess: boolean;
  message: string;
  accessedOn: string | null;
}

// New interface for OTP verification response
export interface OtpVerificationResponse {
  isSuccess: boolean;
  message: string;
}

export interface EdvisorLoginState {
  loginResponse: LoginResponse | null;
  menuResponse: MenuResponse | null;
  menuItems: MenuItem[];
  loading: boolean;
  error: string | null;
  forgotPasswordResponse: ForgotPasswordResponse | null;
  verifyOtpResponse: OtpVerificationResponse | null; // New state
    resetPasswordResponse: OtpVerificationResponse | null;
}

const initialState: EdvisorLoginState = {
  loginResponse: null,
  menuResponse: null,
  menuItems: [],
  loading: false,
  error: null,
  forgotPasswordResponse: null,
  verifyOtpResponse: null, // Initial value
   resetPasswordResponse: null,
};

const EdvisorLoginReducer = (state = initialState, action: any) => {

  switch (action.type) {
    case EDVISOR_LOGIN_AUTHENTICATION:
      return {
        ...state,
        loginResponse: action.payload,
        loading: false,
        error: action.payload?.message && !action.payload?.loginSuccess
          ? action.payload.message
          : null,
      };

    case EDVISOR_LOGIN_GETMENUDETAILS:
      const menuData = action.payload;
      const menuItems = menuData?.records || [];
      return {
        ...state,
        menuResponse: menuData,
        menuItems: menuItems,
        loading: false,
        error: menuData?.isSuccess === false ? menuData.message : null,
      };

    case EDVISOR_FORGOT_PASSWORD:
      return {
        ...state,
        forgotPasswordResponse: action.payload,
        loading: false,
      };

    // New case for OTP verification
    case EDVISOR_VERIFY_OTP:
      return {
        ...state,
        verifyOtpResponse: action.payload,
        loading: false,
      };

      case EDVISOR_RESET_PASSWORD:
      return {
        ...state,
        resetPasswordResponse: action.payload,
        loading: false,
      };

    case EDVISOR_LOGIN_SETSTATE:
      return {
        ...state,
        ...action.payload,
        loading: false,
      };

    case EDVISOR_LOGIN_PAGERESET:
      return initialState;

    default:
      return state;
  }
};

export default EdvisorLoginReducer;